<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-card-actions class=" justify-end">
                        <v-btn color="teal" class="white--text" :disabled="selectedItems.length === 0"
                            @click="exportToXls">
                            {{ $t('exportXLS') }}
                        </v-btn>
                    </v-card-actions>
                    <v-divider></v-divider>
                    <v-card-text class="py-0">
                        <product-filters @filter-change="filterChange" :pageType="pageType"></product-filters>
                    </v-card-text>
                </v-card>
                <v-card>
                    <products-table :filters="filters" :pageType="pageType"
                        @load-error="onDataLoadError"></products-table>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import ProductFilters from "../../../components/filters/ProductFilters";
import ProductsTable from "../../../components/data-tables/products/AdminProductsTable";
import { ExportService } from "../../../services";
import { MixinTableLoadSnack } from "../../../mixins";

export default {
    name: "reviewNewProducts",
    components: {
        ProductFilters,
        ProductsTable,
    },
    mixins: [MixinTableLoadSnack],
    data() {
        return {
            metaUrl: '/products/new-list',
            pageType: 'new',
            filters: {},
        }
    },
    computed: {
        selectedItems() {
            return this.$store.getters.selectedProducts;
        }
    },
    methods: {
        filterChange(filters) {
            this.filters = filters;
        },
        exportToXls() {
            const params = this.selectedItems.map(item => item.id);
            ExportService.products(params)
            this.$store.commit('setSelectedProducts', []);
        },
    },

}
</script>

<style scoped></style>
